import { Menu } from "@base-ui/react/menu";
import * as stylex from "@stylexjs/stylex";
import type { ReactElement, ReactNode } from "react";
import { CheckIcon } from "../icons.ts";
import "../tokens.stylex.ts";
import { color, fontSize, fontWeight, space, zIndex } from "../tokens.stylex.ts";
import { isTransitioning, popupStyles, popupSurface } from "./overlay.styles.ts";
export interface DropdownMenuItem {
  label: ReactNode;
  icon?: ReactNode;
  onSelect?: () => void;
  /** Renders as a link item (e.g. a router `<Link>` element). */
  render?: ReactElement;
  danger?: boolean;
  disabled?: boolean;
}

/** A labelled set of mutually exclusive choices, e.g. a theme picker. */
export interface DropdownMenuRadioGroup<V extends string = string> {
  type: "radio";
  label?: ReactNode;
  value: V;
  // Method syntax keeps a narrowed group (e.g. `"light" | "dark"`) assignable to `items`.
  onValueChange(value: V): void;
  options: {
    value: V;
    label: ReactNode;
    icon?: ReactNode;
  }[];
}
export interface DropdownMenuProps {
  trigger: ReactElement;
  items: (DropdownMenuItem | DropdownMenuRadioGroup | "separator")[];
  align?: "start" | "end";
  header?: ReactNode;
}
export function DropdownMenu({
  trigger,
  items,
  align = "end",
  header
}: DropdownMenuProps) {
  return <Menu.Root>
      <Menu.Trigger render={trigger} />
      <Menu.Portal>
        <Menu.Positioner sideOffset={6} align={align} className="x1xi93jj x1a2a7pz">
          <Menu.Popup className={state => stylex.props(...popupSurface, popupStyles.surface, styles.popup, isTransitioning(state.transitionStatus) && popupStyles.entering).className}>
            {header ? <div className="x1imsgqj x1uu5im9 x1e52oef xso031l x1q0q8m5 xxsbevz">{header}</div> : null}
            {items.map((item, index) => item === "separator" ? <Menu.Separator key={`sep-${index}`} className="xjm9jq1 x1yk1fld xlrb57v" /> : "type" in item ? <Menu.RadioGroup key={index} value={item.value} onValueChange={(value: string) => item.onValueChange(value)}>
                  {item.label ? <Menu.GroupLabel className="x4x6xz0 x1uu5im9 xmccgnw x1219144 xxe3v3u">{item.label}</Menu.GroupLabel> : null}
                  {item.options.map(option => <Menu.RadioItem key={option.value} value={option.value} className={state => stylex.props(popupStyles.menuItem, state.highlighted && popupStyles.menuItemHighlighted).className}>
                      {option.icon ? <span className="x78zum5 xxe3v3u">{option.icon}</span> : null}
                      <span className="x1iyjqo2">{option.label}</span>
                      <Menu.RadioItemIndicator className="x78zum5 x9aqtqa">
                        <CheckIcon size={14} />
                      </Menu.RadioItemIndicator>
                    </Menu.RadioItem>)}
                </Menu.RadioGroup> : <Menu.Item key={index} disabled={item.disabled} onClick={item.onSelect} render={item.render} className={state => stylex.props(popupStyles.menuItem, state.highlighted && popupStyles.menuItemHighlighted, item.danger && popupStyles.menuItemDanger).className}>
                  {item.icon ? <span className="x78zum5 xxe3v3u">{item.icon}</span> : null}
                  {item.label}
                </Menu.Item>)}
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>;
}
const styles = {
  popup: {
    k7Eaqz: "x1jzhcrs",
    kmVPX3: "xbkzfpa",
    $$css: true
  }
};